import { MENU_BY_PATH, MENU_ITEMS, type MenuPermission, type Permission } from '@mt/shared';

/**
 * DEC-446: quyền menu của một đường dẫn (`to` trong nav.ts, ô màn mở đầu, thanh dưới).
 * Khớp đúng cả ?tab= trước; không có thì theo đường dẫn gốc (vd `/doi-xe?tab=gio-cau` theo mục "Xe & giấy tờ").
 */
export function menuPermOf(to: string): MenuPermission | undefined {
  return (MENU_BY_PATH.get(to) ?? MENU_BY_PATH.get(to.split('?')[0]!))?.code;
}

/** Quyền menu các tab của trang gộp (vd /hop-dong-nhan-su → tab thu-viec, lao-dong, ky). */
const tabPermsOf = (base: string): MenuPermission[] => MENU_ITEMS.filter((m) => m.path.startsWith(`${base}?tab=`)).map((m) => m.code);

/** Mục / ô dẫn tới `to` được hiện: không có quyền menu riêng, hoặc người dùng có quyền menu đó; trang gộp: có quyền ít nhất một tab. */
export const menuAllowed = (can: (p: Permission) => boolean, to: string) => {
  const code = menuPermOf(to);
  if (code) return can(code);
  const tabs = tabPermsOf(to.split('?')[0]!);
  return !tabs.length || tabs.some((c) => can(c));
};
